/* ==========================================================================
   ChantForge Classic — theme scripts (vanilla JS, no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var CF = window.CF || {};
  var R = CF.routes || {};
  var S = CF.strings || {};

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function delegate(ev, sel, fn) {
    document.addEventListener(ev, function (e) {
      var t = e.target.closest ? e.target.closest(sel) : null;
      if (t) fn.call(t, e, t);
    });
  }
  function storeGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function storeSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || CF.moneyFormat || '${{amount}}';
    function fmt(n, dec, th, ds) {
      dec = typeof dec === 'number' ? dec : 2;
      th = th || ','; ds = ds || '.';
      var num = (n / 100).toFixed(dec).split('.');
      var whole = num[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return whole + (num[1] ? ds + num[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }
  CF.formatMoney = formatMoney;

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- drawers (menu, cart) ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $$('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = d.querySelector('.drawer__close');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      $$('[data-drawer-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  delegate('click', '[data-drawer-open]', function (e, el) {
    var id = el.getAttribute('data-drawer-open');
    // On the cart page, let the cart link behave normally.
    if (id === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    openDrawer(id);
  });
  delegate('click', '[data-drawer-close]', function (e) { e.preventDefault(); closeDrawers(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeModals(); closePredictive(); closeNav(); }
  });

  /* ---------- desktop nav (touch support) ---------- */
  function closeNav(except) {
    $$('.nav > li.is-open').forEach(function (li) {
      if (li !== except) {
        li.classList.remove('is-open');
        var b = li.querySelector(':scope > button'); if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }
  $$('.nav > li[data-nav-item]').forEach(function (li) {
    var trigger = li.querySelector(':scope > button, :scope > a');
    var panel = li.querySelector(':scope > .mega');
    if (!trigger || !panel) return;
    on(trigger, 'click', function (e) {
      var isTouch = window.matchMedia('(hover: none)').matches;
      if (trigger.tagName === 'BUTTON' || (isTouch && !li.classList.contains('is-open'))) {
        e.preventDefault();
        var open = !li.classList.contains('is-open');
        closeNav(li);
        li.classList.toggle('is-open', open);
        if (trigger.tagName === 'BUTTON') trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.nav')) closeNav(); });

  /* ---------- predictive search ---------- */
  var ps = $('[data-predictive-search]');
  var psInput = ps && $('input[type=search]', ps);
  var psBox = ps && $('#PredictiveResults', ps);
  var psTimer, psCtrl;
  function closePredictive() {
    if (!psBox) return;
    psBox.hidden = true;
    if (psInput) psInput.setAttribute('aria-expanded', 'false');
  }
  if (ps && psInput && psBox && R.predictive) {
    on(psInput, 'input', function () {
      clearTimeout(psTimer);
      var q = psInput.value.trim();
      if (q.length < 2) { closePredictive(); return; }
      psTimer = setTimeout(function () {
        if (psCtrl && psCtrl.abort) psCtrl.abort();
        psCtrl = window.AbortController ? new AbortController() : null;
        var url = R.predictive + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
        fetch(url, psCtrl ? { signal: psCtrl.signal } : {})
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var res = parseHTML(html).querySelector('#predictive-search-results');
            if (!res) { closePredictive(); return; }
            psBox.innerHTML = res.innerHTML;
            psBox.hidden = false;
            psInput.setAttribute('aria-expanded', 'true');
          })
          .catch(function () {});
      }, 250);
    });
    on(psInput, 'keydown', function (e) {
      if (psBox.hidden) return;
      var items = $$('a', psBox);
      if (!items.length) return;
      var idx = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[idx + 1] || items[0]).focus(); }
    });
    on(psBox, 'keydown', function (e) {
      var items = $$('a', psBox);
      var idx = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[idx + 1] || items[0]).focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (idx <= 0) psInput.focus(); else items[idx - 1].focus(); }
    });
    on(psInput, 'focus', function () { if (psBox.innerHTML.trim() && psInput.value.trim().length > 1) { psBox.hidden = false; } });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-predictive-search]')) closePredictive(); });
  }

  /* ---------- slideshow ---------- */
  $$('[data-slideshow]').forEach(function (ss) {
    var slides = $$('.slide', ss);
    var dots = $$('.ss-dots button', ss);
    if (slides.length < 2) return;
    var idx = 0, timer;
    var speed = parseInt(ss.getAttribute('data-speed'), 10) || 6000;
    var auto = ss.getAttribute('data-autoplay') === 'true';
    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); s.setAttribute('aria-hidden', n === idx ? 'false' : 'true'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
    }
    function start() { if (!auto) return; stop(); timer = setInterval(function () { go(idx + 1); }, speed); }
    function stop() { clearInterval(timer); }
    on($('.ss-prev', ss), 'click', function () { go(idx - 1); start(); });
    on($('.ss-next', ss), 'click', function () { go(idx + 1); start(); });
    dots.forEach(function (d, n) { on(d, 'click', function () { go(n); start(); }); });
    on(ss, 'mouseenter', stop); on(ss, 'mouseleave', start);
    on(ss, 'focusin', stop); on(ss, 'focusout', start);
    // swipe
    var x0 = null;
    on(ss, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    on(ss, 'touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(idx + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });
    go(0); start();
  });

  /* ---------- tabs ---------- */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (wrap) {
      var tabs = $$('[role=tab]', wrap).filter(function (t) { return t.closest('[data-tabs]') === wrap; });
      function select(tab) {
        tabs.forEach(function (t) {
          var sel = t === tab;
          t.setAttribute('aria-selected', sel ? 'true' : 'false');
          t.tabIndex = sel ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !sel;
        });
      }
      tabs.forEach(function (t, i) {
        t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
        on(t, 'click', function () { select(t); });
        on(t, 'keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n); n.focus(); }
        });
      });
    });
  }
  initTabs(document);

  /* ---------- toast (errors) ---------- */
  function toast(msg) {
    var t = document.createElement('div');
    t.setAttribute('role', 'alert');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:300;background:#2e2f32;color:#fff;padding:12px 18px;border-radius:3px;box-shadow:0 4px 14px rgba(0,0,0,.3);font-size:14px;max-width:90vw';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }

  /* ---------- cart (AJAX + drawer) ---------- */
  function updateCartCount() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        $$('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
        return cart;
      }).catch(function () {});
  }
  function renderDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var fresh = parseHTML(sections['cart-drawer']).querySelector('[data-cart-drawer-inner]');
    var cur = $('[data-cart-drawer-inner]');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }
  function addToCart(form) {
    var btn = form.querySelector('[type=submit]');
    var err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    return fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = res.data.description || res.data.message || S.cartError;
          if (err) { err.textContent = msg; err.hidden = false; } else { toast(msg); }
          return;
        }
        renderDrawer(res.data.sections);
        updateCartCount();
        openDrawer('CartDrawer');
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ajax-cart], [data-product-form]')) return;
    if (!$('#CartDrawer')) return;
    e.preventDefault();
    addToCart(form);
  });
  function changeLine(line, qty) {
    var inner = $('[data-cart-drawer-inner]');
    if (inner) inner.style.opacity = '.55';
    return fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10) || 0), sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) toast(data.description || data.message || S.cartError);
        renderDrawer(data.sections);
        updateCartCount();
      })
      .catch(function () { window.location.href = R.cart; })
      .then(function () { var i = $('[data-cart-drawer-inner]'); if (i) i.style.opacity = ''; });
  }
  delegate('click', '[data-cart-qty]', function (e, el) { e.preventDefault(); changeLine(el.getAttribute('data-line'), el.getAttribute('data-qty')); });
  delegate('change', '[data-cart-input]', function (e, el) { changeLine(el.getAttribute('data-line'), el.value); });

  /* ---------- quantity +/- (product page) ---------- */
  delegate('click', '[data-qty] [data-step]', function (e, b) {
    var input = b.parentNode.querySelector('input');
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
    input.value = Math.max(parseInt(input.min, 10) || 1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- modals (size guide) ---------- */
  function closeModals() {
    $$('.modal:not([hidden])').forEach(function (m) { m.hidden = true; });
    if (!$('.drawer.is-open')) document.body.style.overflow = '';
  }
  delegate('click', '[data-modal-open]', function (e, b) {
    e.preventDefault();
    var m = document.getElementById(b.getAttribute('data-modal-open'));
    if (!m) return;
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    var c = m.querySelector('[data-modal-close]'); if (c) c.focus();
  });
  delegate('click', '[data-modal-close]', function (e) { e.preventDefault(); closeModals(); });
  delegate('click', '.modal', function (e, m) { if (e.target === m) closeModals(); });

  /* ---------- delivery estimate ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1); // start on a business day
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
    catch (e) { return d.toDateString(); }
  }
  $$('[data-delivery-range]').forEach(function (el) {
    var D = CF.delivery || {};
    var min = (D.procMin || 0) + (D.transMin || 0);
    var max = (D.procMax || 0) + (D.transMax || 0);
    if (!max) return;
    var now = new Date();
    el.innerHTML = '<strong>' + fmtDate(addBusinessDays(now, min)) + ' – ' + fmtDate(addBusinessDays(now, max)) + '</strong> if you order today';
  });

  /* ---------- product page ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var jsonEl = sec.parentNode.querySelector('[data-product-json]') || $('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var inv = {};
    var invEl = $('[data-inventory-json]');
    if (invEl) { try { inv = JSON.parse(invEl.textContent); } catch (e) { inv = {}; } }

    var form = document.getElementById(sec.getAttribute('data-form-id'));
    var idSelect = form && form.querySelector('[data-variant-id]');
    var picker = sec.querySelector('[data-variant-picker]');
    var fieldsets = picker ? $$('fieldset.opt', picker) : [];
    var addBtn = sec.querySelector('[data-add-button]');
    var addIcon = (addBtn && addBtn.querySelector('svg')) ? addBtn.querySelector('svg').outerHTML : '';
    var mainImg = sec.querySelector('[data-main-image]');
    var thumbs = $$('[data-thumb]', sec);
    var sticky = $('[data-sticky-atc]');
    var stickyBtn = sticky && sticky.querySelector('[data-sticky-button]');
    var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');

    // remember for "Recently viewed"
    var handle = sec.getAttribute('data-product-handle');
    if (handle) {
      var list = (storeGet('cf_recent') || []).filter(function (h) { return h !== handle; });
      list.unshift(handle);
      storeSet('cf_recent', list.slice(0, 12));
    }

    function showImage(src, srcset) {
      if (!mainImg || !src) return;
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset; else mainImg.removeAttribute('srcset');
    }
    thumbs.forEach(function (t) {
      on(t, 'click', function () {
        showImage(t.getAttribute('data-src'), t.getAttribute('data-srcset'));
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || opts[i] === undefined || o === opts[i]; });
      })[0];
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[i] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.price > 0 && v.options.every(function (o, j) { return test[j] === null || o === test[j]; });
          });
          input.classList.toggle('is-unavailable', !ok);
        });
        var label = fs.querySelector('[data-selected-label]');
        if (label) label.textContent = opts[i] || '';
      });
    }

    function update(variant) {
      var priceEl = sec.querySelector('[data-price]');
      var cmpEl = sec.querySelector('[data-compare]');
      var saveEl = sec.querySelector('[data-save]');
      var stockEl = sec.querySelector('[data-stock]');
      var skuEl = sec.querySelector('[data-sku]');
      var badge = sec.querySelector('[data-main-badge]');
      var priceWrap = priceEl && priceEl.parentNode;

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = S.unavailable; }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = S.unavailable; }
        if (stockEl) { stockEl.className = 'stock-line out'; stockEl.textContent = '✖ This combination is unavailable'; }
        return;
      }
      if (idSelect) {
        idSelect.value = variant.id;
        idSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (priceWrap) priceWrap.classList.toggle('price--sale', !!sale);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var pct = sale ? Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
      if (cmpEl) { cmpEl.hidden = !sale; cmpEl.textContent = sale ? formatMoney(variant.compare_at_price) : ''; }
      if (saveEl) {
        saveEl.hidden = !sale;
        saveEl.textContent = sale ? (S.save || 'You save [amount] ([percent]%)').replace('[amount]', formatMoney(variant.compare_at_price - variant.price)).replace('[percent]', pct) : '';
      }
      if (badge) { badge.hidden = !(sale && pct >= 5); badge.textContent = '−' + pct + '%'; }
      if (skuEl) skuEl.textContent = variant.sku || '—';

      var buyable = variant.available && variant.price > 0;
      if (stockEl) {
        var low = inv[String(variant.id)];
        if (!buyable) { stockEl.className = 'stock-line out'; stockEl.textContent = '✖ ' + S.outOfStock; }
        else if (low) { stockEl.className = 'stock-line low'; stockEl.textContent = '✔ ' + S.lowStock.replace('[count]', low); }
        else { stockEl.className = 'stock-line in'; stockEl.textContent = '✔ ' + S.inStock; }
      }
      var label = buyable ? S.addToCart : S.soldOut;
      if (addBtn) {
        addBtn.disabled = !buyable;
        addBtn.innerHTML = buyable ? addIcon + ' ' + escapeHTML(S.addToCart) : escapeHTML(S.soldOut);
      }
      if (stickyBtn) { stickyBtn.disabled = !buyable; stickyBtn.textContent = label; }

      if (variant.featured_image) {
        var t = thumbs.filter(function (x) { return x.getAttribute('data-image-id') == variant.featured_image.id; })[0];
        if (t) t.click(); else showImage(variant.featured_image.src);
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    if (fieldsets.length) {
      markAvailability(selectedOptions());
      fieldsets.forEach(function (fs) {
        on(fs, 'change', function () {
          var opts = selectedOptions();
          markAvailability(opts);
          update(findVariant(opts));
        });
      });
    }

    // sticky add-to-cart bar
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('has-sticky-atc', show);
        });
      });
      io.observe(addBtn);
      on(stickyBtn, 'click', function () {
        if (addBtn.disabled) return;
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }
  });

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (box) {
    var url = box.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = parseHTML(html).querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------- recently viewed ---------- */
  $$('[data-recently-viewed]').forEach(function (box) {
    var grid = box.querySelector('[data-recently-viewed-grid]');
    var exclude = box.getAttribute('data-exclude');
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 5;
    var handles = (storeGet('cf_recent') || []).filter(function (h) { return h && h !== exclude; }).slice(0, limit);
    if (!handles.length || !grid) return;
    Promise.all(handles.map(function (h) {
      return fetch((R.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(cardHTML).join('');
      if (!html) return;
      grid.innerHTML = html;
      box.hidden = false;
    });
  });
  function sizedImg(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function cardHTML(p) {
    var price = p.price, cmp = p.compare_at_price;
    var zero = !price;
    var sale = !zero && cmp && cmp > price;
    var pct = sale ? Math.floor((cmp - price) * 100 / cmp) : 0;
    var buyable = p.available && !zero;
    var img = p.featured_image ? '<img src="' + sizedImg(p.featured_image, 400) + '" alt="' + escapeHTML(p.title) + '" loading="lazy">' : '';
    return '<div class="card">' +
      (!p.available ? '<span class="badge badge--sold">Sold out</span>' : (sale && pct >= 5 ? '<span class="badge">−' + pct + '%</span>' : '')) +
      '<a class="card__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="card__info"><div class="card__vendor">' + escapeHTML(p.vendor) + '</div>' +
      '<a class="card__title" href="' + p.url + '">' + escapeHTML(p.title) + '</a></div>' +
      '<div class="card__bottom">' +
      (zero ? '<div class="price"><span class="price__from">Price coming soon</span></div>' :
        '<div class="price' + (sale ? ' price--sale' : '') + '">' + (p.price_varies ? '<span class="price__from">From</span>' : '') +
        '<span class="price__now">' + formatMoney(price) + '</span>' + (sale ? '<span class="price__was">' + formatMoney(cmp) + '</span>' : '') + '</div>') +
      '<div class="card__ship' + (buyable ? '' : ' na') + '">' + (buyable ? '✔ FREE shipping' : 'Currently unavailable') + '</div>' +
      '<a class="btn ' + (buyable ? 'btn--primary' : '') + '" href="' + p.url + '">' + (buyable ? 'View Item' : 'View Details') + '</a>' +
      '</div></div>';
  }

  /* ---------- collection: filters, sort, view ---------- */
  function submitFacets(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
    window.location.href = form.getAttribute('action') + '?' + params.toString();
  }
  $$('[data-facets-form]').forEach(function (form) {
    var t;
    on(form, 'change', function () { clearTimeout(t); t = setTimeout(function () { submitFacets(form); }, 350); });
    on(form, 'submit', function (e) { e.preventDefault(); submitFacets(form); });
  });
  $$('[data-sort]').forEach(function (sel) {
    on(sel, 'change', function (e) {
      e.stopPropagation();
      var form = sel.form;
      if (form && form.matches('[data-facets-form]')) { submitFacets(form); return; }
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  delegate('click', '[data-filter-open]', function (e, b) {
    var p = document.getElementById(b.getAttribute('data-filter-open'));
    if (p) { p.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  });
  delegate('click', '[data-filter-close]', function () {
    $$('[data-filter-panel].is-open').forEach(function (p) { p.classList.remove('is-open'); });
    document.body.style.overflow = '';
  });
  var viewBtns = $$('[data-view]');
  function setView(v) {
    $$('[data-product-grid]').forEach(function (g) { g.classList.toggle('is-list', v === 'list'); });
    viewBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-view') === v); });
  }
  viewBtns.forEach(function (b) {
    on(b, 'click', function () { var v = b.getAttribute('data-view'); setView(v); storeSet('cf_view', v); });
  });
  if (viewBtns.length && storeGet('cf_view') === 'list') setView('list');

  /* ---------- back to top ---------- */
  var top = $('.back-top');
  if (top) {
    on(window, 'scroll', function () { top.classList.toggle('is-visible', window.scrollY > 600); }, { passive: true });
    on(top, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }
})();
